module.exports = __webpack_public_path__ + "img/drawer_white.974b7831.svg";